import { useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { IoChevronDownSharp } from 'react-icons/io5';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { urlAppendParam } from 'utils/tabsHeaderUtils';

const MobileTabsHeader = ({ variant = 'primary', options, param = 'tab' }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const rawParam = searchParams.get(param);

  const normalizedOptions = options?.map((item) => ({
    option: item.option,
    normalized: item.option?.toLowerCase(),
  }));
  const activeOption =
    normalizedOptions?.find((item) => item.normalized === rawParam?.toLowerCase()) ||
    normalizedOptions?.[0];

  useEffect(() => {
    if (!activeOption || !rawParam) return;
    if (rawParam === activeOption.option) return;
    navigate(urlAppendParam(param, activeOption.option), { replace: true });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOption?.option, navigate, param, rawParam]);

  const toggleTxt = activeOption?.option || options?.[0]?.option;

  return (
    <Dropdown className="mt-3 ">
      <Dropdown.Toggle
        variant={variant}
        className="w-100 p-3 d-flex justify-content-between align-items-center"
      >
        {toggleTxt}
        <IoChevronDownSharp size={30} />
      </Dropdown.Toggle>
      <Dropdown.Menu className="w-100">
        {options?.map((item, index) => (
          <Dropdown.Item
            key={index}
            as={Link}
            to={urlAppendParam(param, item?.option)}
            className="fs-6"
          >
            {item?.option}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MobileTabsHeader;
